module.exports = __webpack_public_path__ + "img/image-style-04.71bbcec2.svg";